export interface TimelineViewStateComparable {
  textFilter: string;
  selectedItemTypes: string[];
  selectedTags: string[];
  excludedTags?: string[];
  selectedDocumentId?: string;
  groupBy: string;
  groupByTypes: string[];
  groupByTags: string[];
  groupByDocuments?: string[];
  viewMode: string;
  timelineWindow?: { start: string; end: string } | null;
  detailLevel?: string | null;
}

function sortedCopy(values: string[] | undefined): string[] {
  return [...(values ?? [])].sort();
}

export function normalizeTimelineViewStateForCompare(
  state: TimelineViewStateComparable
): TimelineViewStateComparable {
  return {
    textFilter: state.textFilter ?? '',
    selectedItemTypes: sortedCopy(state.selectedItemTypes),
    selectedTags: sortedCopy(state.selectedTags),
    excludedTags: sortedCopy(state.excludedTags),
    selectedDocumentId: state.selectedDocumentId ?? '',
    groupBy: state.groupBy ?? 'none',
    groupByTypes: sortedCopy(state.groupByTypes),
    groupByTags: sortedCopy(state.groupByTags),
    groupByDocuments: sortedCopy(state.groupByDocuments),
    viewMode: state.viewMode ?? 'timeline',
    timelineWindow:
      state.timelineWindow?.start && state.timelineWindow?.end
        ? { start: state.timelineWindow.start, end: state.timelineWindow.end }
        : null,
    detailLevel: state.detailLevel ?? null,
  };
}

export function areTimelineViewStatesEqual(
  a: TimelineViewStateComparable,
  b: TimelineViewStateComparable
): boolean {
  return (
    JSON.stringify(normalizeTimelineViewStateForCompare(a)) ===
    JSON.stringify(normalizeTimelineViewStateForCompare(b))
  );
}
